// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Scalars = require("../../scalars/Scalars.bs.js");

function encodeUrl(url) {
  return encodeURIComponent(Scalars.$$URL.toString(url));
}

function makeFacebookShareUrl(url) {
  return "https://www.facebook.com/sharer/sharer.php?u=" + encodeUrl(url);
}

function makeTwitterShareUrl(url) {
  return "https://twitter.com/intent/tweet?url=" + encodeUrl(url);
}

function makeEmailShareUrl(url) {
  return "mailto:?subject=My profile on Top Agent Network&body=" + encodeUrl(url);
}

exports.encodeUrl = encodeUrl;
exports.makeFacebookShareUrl = makeFacebookShareUrl;
exports.makeTwitterShareUrl = makeTwitterShareUrl;
exports.makeEmailShareUrl = makeEmailShareUrl;
/* Scalars Not a pure module */
